<template>
  <el-dialog  class="toTest_model_dialog" top="5vh" center
    :title="'缺陷-【' + formInfo.db_id + '】' + formInfo.db_title" width="90%"
    :before-close="handleClose" :visible.sync="dialogVisible" :close-on-click-modal="false">
    <el-form size="mini" :model="formInfo">
      <el-form-item label="任务内容"  prop="context" :label-width="formLabelWidth" >
        <Editor :content="formInfo.db_context"
                 :dialogVisibleModelType="form.id ? 'update' : 'create'" />
      </el-form-item>
      <div style="display: flex;">
        <el-form-item label="类型" :label-width="formLabelWidth">
          <div style="white-space: nowrap;"> {{formInfo.db_task_type}}</div>
        </el-form-item>
        <el-form-item label="严重程度" :label-width="formLabelWidth">
          <div style="white-space: nowrap;"> {{allSelect.BUGTASKPRIORITY[formInfo.db_severity]}}</div>
        </el-form-item>
        <el-form-item label="优先级" label-width="262px">
          <div style="white-space: nowrap;">{{formInfo.db_priority}}</div>
        </el-form-item>
      </div>
      <div style="display: flex;">
        <el-form-item label="关联任务" :label-width="formLabelWidth">
          <div style="white-space: nowrap;"> 【{{formInfo.db_related_task_id}}】{{formInfo.d_title}}</div>
        </el-form-item>
        <el-form-item label="负责人" label-width="137px">
          {{allSelect.TEXTALLUSERSEN[formInfo.db_leading]}}
        </el-form-item>
        <el-form-item label="系统" label-width="160px">
          <div style="white-space: nowrap;"> {{allSelect.TEXTMODULES[formInfo.db_module]}}</div>
        </el-form-item>
      </div>
      <div style="display: flex;">
        <el-form-item label="计划开始日期" label-width="220px">
          {{ formatTimeToDate(formInfo.db_plt * 1, "YYYY-MM-DD HH:mm:ss") }}
        </el-form-item>
        <el-form-item label="计划完成日期" label-width="150px">
          {{ formatTimeToDate(formInfo.db_plet * 1, "YYYY-MM-DD HH:mm:ss") }}
        </el-form-item>
        <el-form-item label="创建人" label-width="140px">
          <div style="white-space: nowrap;">{{allSelect.TEXTALLUSERSEN[formInfo.db_creator]}}</div>
        </el-form-item>
      </div>
      <div style="display: flex">
        <el-form-item label="创建时间" label-width="195px">
          <div style="white-space: nowrap;">{{ formatTimeToDate(formInfo.db_create_time * 1, "YYYY-MM-DD HH:mm:ss") }}</div>
        </el-form-item>
        <el-form-item label="状态" label-width="175px">
          {{ allSelect.BUGTASKSTATUS[formInfo.db_status] }}
        </el-form-item>
        <el-form-item label="是否确认为Bug" prop="db_is_bug" label-width="280px">
          <span v-if="formInfo.db_is_bug === 1">是</span>
          <span v-else>否</span>
        </el-form-item>
      </div>
      <el-form-item label="处理内容"  prop="details" :label-width="formLabelWidth" >
        <Editor  :content="formInfo.db_operator_context"
                  :dialogVisibleModelType="form.id ? 'update' : 'create'" />
      </el-form-item>
      <el-form :model="formInfo" v-if="formInfo.db_id">
        <el-form-item class="comment_warp" label="评论" :model="formInfo" :label-width="formLabelWidth">
          <Comment  :tid="String(formInfo.db_id)" type="bug_task" />
        </el-form-item>
      </el-form>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button v-show="showButton()" type="primary" :loading="loading.submit" @click="submit('verify')">通 过</el-button>
      <el-button v-show="showButton()" type="warning" :loading="loading.submitpass" @click="submit('pass')">驳 回</el-button>

      <el-button type="primary" @click="handleClose">关 闭</el-button>
    </div>
  </el-dialog>
</template>
<script>
import {
  postDevOpsSpaceUpdateBugTaskApi,
  getDevOpsSpaceBugDetailApi,
} from "@/server/tops/devOps";
import { mapState } from "vuex";
import {Editor} from "@/components";
import {
  formatTimeToDate,
} from "@/views/tops/devOps/components/util.js";
import Comment from '@/views/tops/devOps/producerSpace/components/comment.vue'
export default {
  components: {Editor, Comment},
  props: {
    formInfo: {
      type: Object,
      default: function () {
        return {};
      },
    },
    dialogVisible: {
      type: Boolean,
      default: function () {
        return false;
      },
    },
    hideDialogVisible: {
      type: Function,
      default: function () {
        return () => { };
      },
    },
  },
  data() {
    return {
      form: {
      },
      formLabelWidth: "200px",
      loading: {
        submit: false,
        dialog: true,
        submitpass: false,
      }
    };
  },
  async created() {
    await this.getOtherDetailApi();
  },
  computed: {
    ...mapState({
      allSelect: (state) => state.devOps.ALLSELECT,
    }),
  },
  methods: {
    showButton(){
      return this.formInfo.db_creator === this.formInfo.user;
    },
    // 关闭弹窗
    handleClose(step) {
      this.hideDialogVisible(step);
    },
    async getOtherDetailApi() {
      const loginusername = this.$store.state.devOps.userInfo.devops_name? this.$store.state.devOps.userInfo.devops_name : '';
      const { db_id = "" } = this.formInfo || {};
      try {
        const ret = await getDevOpsSpaceBugDetailApi({
          id: db_id,
        });
        const info = ret.data[0] || {};
        this.formInfo = {
          ...this.formInfo,
          db_title: info.db_title,
          db_context: info.db_context,
          db_create_time: info.db_create_time,
          db_leading: info.db_leading,
          db_module: info.db_module,
          db_operator_context: info.db_operator_context,
          db_plet: info.db_plet,
          db_plt: info.db_plt,
          db_priority: info.db_priority,
          db_related_task_id: info.db_related_task_id,
          db_severity: info.db_severity,
          db_status: info.db_status,
          db_task_type: info.db_task_type,
          project_system: info.project_system,
          db_creator: info.db_creator,
          db_is_bug: info.db_is_bug,
          user: loginusername,
        };
      } catch (error) {
        this.$notify({
          message: error || "获取详情失败",
          type: "error",
        });
      }
    },
    // 提交
    async submit(action) {
      try {
        if(action === "verify"){
          this.loading.submit = true;
        }
        if(action === "pass"){
          this.loading.submitpass = true;
        }
        const loginusername = this.$store.state.devOps.userInfo.devops_name? this.$store.state.devOps.userInfo.devops_name : '';
        const {
          db_id = "",
          db_title = "",
          db_leading = "",
          db_creator = "",
        } = this.formInfo;
        const param = {
          id: db_id,
          leading: db_leading,
          creator: db_creator,
          username: loginusername,
          flag: action,
          title: db_title,
        };
        const ret = await postDevOpsSpaceUpdateBugTaskApi(param);
        let output = ret.data?.output || {};
        if (ret.status === 'success') {
          this.handleClose()
          this.$notify({
            message: ret.data?.msg || "提交成功",
            type: "success",
          });
        } else {
          this.$notify({
            message: ret.data.msg,
            type: 'error'
          })
        }
      } catch (error) {
        this.$notify({
          message: error || '提测失败',
          type: 'error'
        })
      } finally {
        if(action === "verify"){
          this.loading.submit = true;
        }
        if(action === "pass"){
          this.loading.submitpass = true;
        }

      }

    },
    formatTimeToDate,
  },
};
</script>
<style lang="scss">
.toTest_model_dialog {
  .el-dialog__body {
    padding-bottom: 0;
  }
}
.el-form-item--mini .el-form-item__content, .el-form-item--mini .el-form-item__label {
  line-height: 16px;
}
</style>